"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";

const WhatsAppButton = () => {
  const [showButton, setShowButton] = useState(true);
  useEffect(() => {
    const checkScheduleAndDisplayButton = () => {
      const now = new Date();
      const dayOfWeek = now.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
      const startHour = 0; // 10 AM
      const endHour = 23; // 5 PM

      // Convert current time and scheduled hours to minutes for comparison
      const currentTimeInMinutes = now.getHours() * 60 + now.getMinutes();
      const startTimeInMinutes = startHour * 60;
      const endTimeInMinutes = endHour * 60;

      // Check if current time is within the schedule and on a weekday
      // if (
      //   dayOfWeek >= 0 &&
      //   dayOfWeek <= 6 &&
      //   currentTimeInMinutes >= startTimeInMinutes &&
      //   currentTimeInMinutes <= endTimeInMinutes
      // ) {
      //   setShowButton(true);
      // } else {
      //   setShowButton(false);
      // }
    };

    checkScheduleAndDisplayButton();
    const interval = setInterval(checkScheduleAndDisplayButton, 60000);

    return () => clearInterval(interval);
  }, []);

  if (!showButton) return null;

  return (
    <Link
      href="https://wa.me/+447427842412"
      aria-label="Chat with us on WhatsApp"
      passHref
      style={{
        position: "fixed",
        bottom: "20px",
        left: "20px",
        display: "block",
        width: "204px",
        height: "46px",
        backgroundImage:
          "url(https://pro-ear-clinic.cdn.prismic.io/pro-ear-clinic/aSi8anNYClf9njqI_WhatsButton.svg)",
        backgroundSize: "cover",
        zIndex: 9999,
      }}
    ></Link>
  );
};

export default WhatsAppButton;
